export default __webpack_public_path__ + "static/media/Icon-material-person-dark.0fe89a98.svg";